import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import { Actions } from "src/types";
import styled from "styled-components";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import Button from "@/components/editor/primitives/button/button-component";
import RichText from "@/components/editor/primitives/rich-text";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

const StyledContainer = styled.div`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(24)};

  h3,
  p {
    margin-bottom: 0;
  }
`;

const StyledButtonContainer = withViewportStyle("div")`
  .button-primitive {
    font-size: ${rem(15)};
    font-weight: 500;
    padding: ${rem(10)} ${rem(40)};
    line-height: ${rem(28)};
    max-width: ${rem(300)};
    width: max-content;
    
    ${(props) => props.$viewport.mobile`
      padding: ${rem(12)};
      max-width: 100%;
      width: 100%;
    `}
  }
  `;

export type ParagraphItemProps = {
  showCTA?: boolean;
};

export default function ParagraphItem(props: ParagraphItemProps) {
  const {
    connectors: { connect },
  } = useNode();

  return (
    <StyledContainer ref={connect}>
      <Element
        id="paragraph-item-sub-title"
        is={RichText}
        text={`<h3>Join our first digital conference.</h3>`}
      />
      <Element
        id="paragraph-item-description"
        is={RichText}
        text={`<p>We’re here to help shape the future in a sustainable way. Our team is made of experts that help companies invest in renewable energy, and we support many initiatives to make the food industry more sustainable for our planet.</p>`}
      />
      {props.showCTA && (
        <StyledButtonContainer>
          <Element
            id="cta-button"
            is={Button}
            text="Register"
            action={{
              kind: Actions.TicketSelector,
            }}
          />
        </StyledButtonContainer>
      )}
    </StyledContainer>
  );
}

ParagraphItem.craft = {
  custom: {
    displayName: "Paragraph Item",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
  },
};
